import {textComponent} from 'quickstart/components/content/Text'
import {withClassNames} from 'quickstart/theme'
import * as R from 'rambdax'
import S from './styles.module.css'

export const Form = withClassNames(S.form)('form')

// Apply form font, since it's harder to apply in Input, Select, etc. This could
// be reverted to body font by an internal component as needed. We don't apply
// in Form above because it's hard to combine Text and AK.Form.
export const Field = R.piped(
  textComponent({font: 'ui', variant: 'form'}),
  withClassNames(S.field),
)

// TODO: old fieldStyles had variant colors, transition

export const Input = R.piped(
  textComponent({
    font: 'ui',
    variant: 'form',
    as: 'input',
  }) as unknown as 'input',
  withClassNames(S.input),
)

export const Buttons = withClassNames(S.buttons)('div')

export const LabelWrapper = withClassNames(S['label-wrapper'])('div')

export const RightLabel = withClassNames(S['right-label'])('div')

export const Hint = R.piped(
  textComponent({font: 'ui', variant: 'formMeta', italic: true}),
  withClassNames(S.hint),
)

export const Select = R.piped(
  textComponent({
    font: 'ui',
    variant: 'form',
    as: 'button',
  }) as unknown as 'button',
  withClassNames(S.select),
)

export const PickerItem = withClassNames(S['picker-item'])('div')

// This builds on Field for the sake of size control.
export const PickerPopover = withClassNames(S['picker-popover'])(Field)

export const Checklist = withClassNames(S.checklist)('div')

export const CheckLabel = withClassNames(S['check-label'])('label')

export const Check = withClassNames(S.check)('div')

export const Radio = withClassNames(S.radio)('div')

export const RadioWrapper = withClassNames(S['radio-wrapper'])('label')

export const RadioColumn = withClassNames(S['radio-column'])('div')

export const RadioButton = withClassNames(S['radio-button'])('input')

export const RadioLabel = withClassNames(S['radio-label'])('div')

export const Error = withClassNames(S.error)('div')
